import type { NextPage } from 'next';
import dynamic from 'next/dynamic';
import React from 'react';

import PageNextJs from 'nextjs/PageNextJs';

const ApiPlans = dynamic(() => import('ui/pages/ApiPlans'), { ssr: false });

const Page: NextPage = () => {
  return (
    <PageNextJs pathname="/api-plans">
      <ApiPlans/>
    </PageNextJs>
  );
};

export default Page;

export { base as getServerSideProps } from 'nextjs/getServerSideProps';
